import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=cityCentralActivityZone&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '城市中央活力区（CAZ）',
        pageTitleIcon: '',
        background_img: '',
        description: `华美深度聚焦高端酒店及商业综合体的区位价值优化。当前许多项目面临业态同质化严重、客群定位不精准、空间与城市功能脱节等共性问题。华美基于城市能级评估与消费行为研究确立差异化定位，通过复合场景的沉浸式设计塑造独特体验，帮助客户在稀缺的城市核心地段实现资产价值的最大化释放。`,
        icons: [
            {
                name: '中央活力区',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/19.中央活力区.pdf'),
                path: "四库赋能-酒店+/城市中央活力区（CAZ）/城市中央活力区（CAZ）"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/城市中央活力区（CAZ）/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市中央活力区（CAZ）/数据赋能'),
                path: "四库赋能-酒店+/城市中央活力区（CAZ）/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市中央活力区（CAZ）/全球案例/全球案例（城市中央活力区（CAZ））.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/城市中央活力区（CAZ）/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市中央活力区（CAZ）/预警问题/预警问题（城市中央活力区（CAZ））.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/城市中央活力区（CAZ）/预警问题"
            }
        ]
    }]
}